<div [style]="boxStyle">
	@if (isLoading) {
		<mat-spinner [diameter]="diameter" [style]="spinnerStyle"></mat-spinner>
	}
	@if (!isLoading) {
		<ng-content></ng-content>
	}
</div>
